export default __webpack_public_path__ + "images/daba70a4ebf0945b625779a768a88878.webp";